import { useEffect, useState } from "react";
import Sidebar from "../AdminComp/Sidebar";
import BreadCrumb from "../AdminComp/BreadCrumb";
import { Eye } from "react-feather";
import { baseurl } from "../../../component/Baseurl";
import axios from "axios";
import AdminBookingNavbar from "./AdminBookingNavbar";

function AdminGstReport() {
  const [gstData, setGstData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch GST data from API
  const fetchGstData = async () => {
    try {
      const response = await axios.get(`${baseurl}/getWalletReasonsWithGST`);
      console.log("API Response:", response.data);

      if (response.data.wallet_reasons) {
        setGstData(response.data.wallet_reasons);
      } else {
        setGstData([]);
      }
    } catch (error) {
      console.error("Error fetching GST data:", error);
      setError("Failed to load GST report.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGstData();
  }, []);

  return (
    <>
      <div className="App" style={{ display: "flex" }}>
        <Sidebar />

        {/* Content area */}
        <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
          <div>
            <BreadCrumb />
            <div className="container-fluid">
              <AdminBookingNavbar />

              <div className="crdmain mb-2">
                <div className="d-flex justify-content-between align-items-center" style={{ width: "100%" }}>
                  <h2 className="chart-title mb-0">GST Report</h2>
                </div>

                {/* Show loading or error */}
                {loading && <p>Loading GST report...</p>}
                {error && <p className="text-danger">{error}</p>}

                {!loading && !error && (
                  <div className="row g-2 mt-0 mb-0">
                    <div className="col-md-12 p-2">
                      {/* Table */}
                      <div className="table-responsive classic-table">
                        <table className="table table-striped table-hover">
                          <thead className="table-header">
                            <tr>
                              <th>#</th>
                              <th>User Name</th>
                              <th>User Type</th>
                              <th>Amount</th>
                              <th>GST Amount</th>
                              <th>Transaction Type</th>
                              <th>Transaction Reason</th>
                              <th>Booking For</th>
                              <th>Booking ID</th>
                              <th>Date</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {gstData.length > 0 ? (
                              gstData.map((gst, index) => (
                                <tr key={gst.id}>
                                  <td>{index + 1}</td>
                                  <td>{gst.user_name}</td>
                                  <td>{gst.user_type}</td>
                                  <td>&#8377; {gst.amount}</td>
                                  <td>&#8377; {gst.gst}</td>
                                  <td>
                                    <span className={`badge 
                                      ${gst.transaction_type === "credit" ? "bg-success" : "bg-danger"}
                                    `}>
                                      {gst.transaction_type}
                                    </span>
                                  </td>
                                  <td>{gst.transaction_reason}</td>
                                  <td>{gst.booking_for}</td>
                                  <td>{gst.booking_unique_id}</td>
                                  <td>{new Date(gst.created_at).toLocaleDateString()}</td>
                                  <td>
                                    <span className="btn2 me-2" title="View Details">
                                      <Eye size={15} />
                                    </span>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="11" className="text-center">
                                  No GST records found.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminGstReport;
